/*
 *
 *  actions
 *
 */

import {
  //LOAD_VIDEO_TEAM
  LOAD_ITEMS,
  LOAD_ITEMS_SUCCESS,
  LOAD_ITEMS_ERROR,
  CREATE_ITEMS,
  CREATE_ITEMS_SUCCESS,
  CREATE_ITEMS_ERROR,
  LOAD_CATEGORY,
  LOAD_CATEGORY_SUCCESS,
  LOAD_CATEGORY_ERROR,
  CREATE_CATEGORY,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_ERROR,
  ADJUST_STOCK,
  ADJUST_STOCK_SUCCESS,
  ADJUST_STOCK_ERROR,
  UPDATE_ITEMS,
  UPDATE_ITEMS_SUCCESS,
  UPDATE_ITEMS_ERROR,
  DELETE_ITEMS,
  DELETE_ITEMS_SUCCESS,
  DELETE_ITEMS_ERROR,
  LOAD_ITEMS_RECORDS_META_DATA,
  LOAD_ITEMS_RECORDS_META_DATA_SUCCESS,
  LOAD_ITEMS_RECORDS_META_DATA_ERROR,
  STOCK_DETAILS,
  STOCK_DETAILS_SUCCESS,
  STOCK_DETAILS_ERROR,
  LOAD_PARTY_WISE_REPORT,
  LOAD_PARTY_WISE_REPORT_SUCCESS,
  LOAD_PARTY_WISE_REPORT_ERROR,
  LOAD_STOCK_VALUE,
  LOAD_STOCK_VALUE_SUCCESS,
  LOAD_STOCK_VALUE_ERROR,
} from "./constants";

export function loadRecordsCacheHit() {
  return {
    // type: LOAD_RECORDS_VALID_CACHE  organization_list
  };
}

//loadOrganizationList
export function loadItems(itemList) {
  return {
    type: LOAD_ITEMS,
    itemList,
  };
}

export function loadItemsSuccess(items_list, success) {
  return {
    type: LOAD_ITEMS_SUCCESS,
    items_list,
    success,
  };
}

export function loadItemsError(error) {
  return {
    type: LOAD_ITEMS_ERROR,
    error,
  };
}

//Stock details
export function loadStockValueList(stockDetails) {
  return {
    type: LOAD_STOCK_VALUE,
    stockDetails,
  };
}

export function loadStockValueListSuccess(stock_value_list, success) {
  return {
    type: LOAD_STOCK_VALUE_SUCCESS,
    stock_value_list,
    success,
  };
}

export function loadStockValueListError(error) {
  return {
    type: LOAD_STOCK_VALUE_ERROR,
    error,
  };
}

//loadOrganizationList
export function createItemList(itemList) {
  return {
    type: CREATE_ITEMS,
    itemList,
  };
}

export function createItemListSuccess(itemList, success) {
  return {
    type: CREATE_ITEMS_SUCCESS,
    itemList,
    success,
  };
}

export function createItemListError(error) {
  return {
    type: CREATE_ITEMS_ERROR,
    error,
  };
}
//loadOrganizationList
export function updateItemList(itemList) {
  return {
    type: UPDATE_ITEMS,
    itemList,
  };
}

export function updateItemListSuccess(itemList, success) {
  return {
    type: UPDATE_ITEMS_SUCCESS,
    itemList,
    success,
  };
}

export function updateItemListError(error) {
  return {
    type: UPDATE_ITEMS_ERROR,
    error,
  };
}
//loadOrganizationList
export function deleteItemList(itemList) {
  return {
    type: DELETE_ITEMS,
    itemList,
  };
}

export function deleteItemListSuccess(itemList, success) {
  return {
    type: DELETE_ITEMS_SUCCESS,
    itemList,
    success,
  };
}

export function deleteItemListError(error) {
  return {
    type: DELETE_ITEMS_ERROR,
    error,
  };
}

export function loadItemsRecordsMetaData() {
  return {
    type: LOAD_ITEMS_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadItemsRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_ITEMS_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadItemsRecordsMetaDataError(error) {
  return {
    type: LOAD_ITEMS_RECORDS_META_DATA_ERROR,
    error,
  };
}

// Category

export function loadCategory(categoryList) {
  return {
    type: LOAD_CATEGORY,
    categoryList,
  };
}

export function loadCategorySuccess(category_list, success) {
  return {
    type: LOAD_CATEGORY_SUCCESS,
    category_list,
    success,
  };
}

export function loadCategoryError(error) {
  return {
    type: LOAD_CATEGORY_ERROR,
    error,
  };
}

//category list
export function createCategoryList(categoryList) {
  return {
    type: CREATE_CATEGORY,
    categoryList,
  };
}

export function createCategoryListSuccess(categoryList, success) {
  return {
    type: CREATE_CATEGORY_SUCCESS,
    categoryList,
    success,
  };
}

export function createCategoryListError(error) {
  return {
    type: CREATE_CATEGORY_ERROR,
    error,
  };
}

//adjust stock
export function adjustStockList(stockList) {
  return {
    type: ADJUST_STOCK,
    stockList,
  };
}

export function adjustStockListSuccess(stockList, success) {
  return {
    type: ADJUST_STOCK_SUCCESS,
    stockList,
    success,
  };
}

export function adjustStockListError(error) {
  return {
    type: ADJUST_STOCK_ERROR,
    error,
  };
}

// Category

export function loadStockList(stockDetails) {
  return {
    type: STOCK_DETAILS,
    stockDetails,
  };
}

export function loadStockListSuccess(stock_details, success) {
  return {
    type: STOCK_DETAILS_SUCCESS,
    stock_details,
    success,
  };
}

export function loadStockListError(error) {
  return {
    type: STOCK_DETAILS_ERROR,
    error,
  };
}

// Category

export function loadPartyWiseReport(partyList) {
  return {
    type: LOAD_PARTY_WISE_REPORT,
    partyList,
  };
}

export function loadPartyWiseReportSuccess(party_list, success) {
  return {
    type: LOAD_PARTY_WISE_REPORT_SUCCESS,
    party_list,
    success,
  };
}

export function loadPartyWiseReportError(error) {
  return {
    type: LOAD_PARTY_WISE_REPORT_ERROR,
    error,
  };
}

const actions = {
  loadItems,
  loadItemsSuccess,
  loadItemsError,

  createItemList,
  createItemListSuccess,
  createItemListError,

  loadCategory,
  loadCategorySuccess,
  loadCategoryError,

  createCategoryList,
  createCategoryListSuccess,
  createCategoryListError,

  loadStockList,
  loadStockListSuccess,
  loadStockListError,

  loadStockValueList,
  loadStockValueListSuccess,
  loadStockValueListError,

  loadPartyWiseReport,
  loadPartyWiseReportSuccess,
  loadPartyWiseReportError,



  adjustStockList,
  adjustStockListSuccess,
  adjustStockListError,

  updateItemList,
  updateItemListSuccess,
  updateItemListError,

  deleteItemList,
  deleteItemListSuccess,
  deleteItemListError,

  loadRecordsCacheHit,
  loadItemsRecordsMetaData,
  loadItemsRecordsMetaDataSuccess,
  loadItemsRecordsMetaDataError,
};

export default actions;
